import { FilterSlices } from '@griply/utils';
import { createContext } from 'react';

export type FilterSlicesContextProps = {
  // undefined outside the provider — consumers must fall back to internal derivation, not empty slices
  slices: FilterSlices | undefined;
};

export const FilterSlicesContext = createContext<FilterSlicesContextProps>({
  slices: undefined,
});
